import { observer } from 'mobx-react-lite'
import { useRegionRouterStore } from 'features/main/RegionRouterStore'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { completeCalendarOAuthCallback } from '../utils/calendarOAuthCallback'
import { takeOAuthCallbackSearch } from '../utils/oauth-callback-search'

/**
 * Landing route the provider redirects to after consent. Completes the OAuth flow (the backend
 * verifies the state against the signed-in advisor) and routes back to My Profile.
 */
export default observer(function RecallCalendarOAuthCallback() {
   const regionRouterStore = useRegionRouterStore()

   useInitialMount(async () => {
      // Prefer the stash written before Sentry initialised; fall back to the address bar and strip
      // it so a mount that skipped index.tsx still cannot leave the code in the href.
      const searchParams = takeOAuthCallbackSearch()
      if (window.location.search) {
         window.history.replaceState(null, '', window.location.pathname)
      }
      const { returnPath } = await completeCalendarOAuthCallback({ searchParams })
      const regionPrefix = `/${regionRouterStore.region}`
      const regionlessPath = returnPath.startsWith(regionPrefix) ? returnPath.slice(regionPrefix.length) : returnPath
      regionRouterStore.navigate(regionlessPath)
   })

   return null
})
